import { couponType } from "@/helpers/translateEnums";

const discountValue = (context, price, offer) => {
  if (offer.rewards.deliveryFeeExemption) return null;

  return couponType(context, offer.rewards.discountType.type)
    ? price * (offer.rewards.discountType.value / 100)
    : offer.rewards.discountType.value;
};

const productDiscount = (offers, offerId) => {
  let result = [];

  let aux = offers.filter((offer) => offer._id === offerId);

  if (aux.length) result.push(aux[0]);

  return result;
};

export { discountValue, productDiscount };
